import { useEffect, useState } from 'react';

const API = (process.env.REACT_APP_API_URL || 'http://localhost:8000') + '/api/ic-kontrol';

const BILDIRIM_TURLERI = [
  { value: 'hata',      label: 'Hata',       ikon: '⚠️', renk: '#b45309', bg: '#fffbeb' },
  { value: 'usulsuzluk',label: 'Usulsüzlük', ikon: '🚫', renk: '#d03801', bg: '#fff7ed' },
  { value: 'yolsuzluk', label: 'Yolsuzluk',  ikon: '🔴', renk: '#991b1b', bg: '#fef2f2' },
  { value: 'diger',     label: 'Diğer',       ikon: '📋', renk: '#374151', bg: '#f9fafb' },
];

const DURUMLAR = [
  { value: 'beklemede',   label: 'Beklemede',   bg: '#fef3c7', text: '#92400e' },
  { value: 'inceleniyor', label: 'İnceleniyor', bg: '#dbeafe', text: '#1e40af' },
  { value: 'tamamlandi',  label: 'Tamamlandı',  bg: '#d1fae5', text: '#065f46' },
  { value: 'reddedildi',  label: 'Reddedildi',  bg: '#f3f4f6', text: '#6b7280' },
];

const BOŞ: any = {
  bildirim_turu: 'hata', konu: '', aciklama: '', gerceklestigi_birim: '',
  tahmini_etki: '', anonim_mi: false, bildiren_adi: '',
};

export default function IcKontrolBildirimler() {
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };

  const [bildirimler, setBildirimler] = useState<any[]>([]);
  const [filtreDurum, setFiltreDurum] = useState('');
  const [filtreType, setFiltreType] = useState('');
  const [modal, setModal] = useState<'' | 'yeni' | 'detay'>('');
  const [secili, setSecili] = useState<any>(null);
  const [form, setForm] = useState({ ...BOŞ });
  const [incelemeNotu, setIncelemeNotu] = useState('');
  const [yeniDurum, setYeniDurum] = useState('');
  const [kaydediliyor, setKaydediliyor] = useState(false);

  const yukle = () => {
    const p: Record<string, string> = {};
    if (filtreDurum) p.durum = filtreDurum;
    if (filtreType) p.bildirim_turu = filtreType;
    const qs = new URLSearchParams(p).toString();
    fetch(`${API}/bildirimler${qs ? '?' + qs : ''}`, { headers })
      .then(r => r.json()).then(d => setBildirimler(Array.isArray(d) ? d : []));
  };

  useEffect(() => { yukle(); }, [filtreDurum, filtreType]);

  const kaydet = async () => {
    setKaydediliyor(true);
    const res = await fetch(`${API}/bildirimler`, { method: 'POST', headers, body: JSON.stringify(form) });
    if (res.ok) { setModal(''); setForm({ ...BOŞ }); yukle(); }
    setKaydediliyor(false);
  };

  const durumGuncelle = async () => {
    if (!secili || !yeniDurum) return;
    setKaydediliyor(true);
    await fetch(`${API}/bildirimler/${secili.id}`, {
      method: 'PUT', headers,
      body: JSON.stringify({ durum: yeniDurum, inceleme_notu: incelemeNotu })
    });
    setModal('');
    setSecili(null);
    yukle();
    setKaydediliyor(false);
  };

  const durumBilgi = (d: string) => DURUMLAR.find(x => x.value === d) || DURUMLAR[0];
  const turBilgi = (t: string) => BILDIRIM_TURLERI.find(x => x.value === t) || BILDIRIM_TURLERI[0];

  const bekleyen = bildirimler.filter(b => b.durum === 'beklemede').length;
  const inceleniyor = bildirimler.filter(b => b.durum === 'inceleniyor').length;
  const tamamlanan = bildirimler.filter(b => b.durum === 'tamamlandi').length;

  return (
    <div style={{ padding: '24px', maxWidth: 1100 }}>
      {/* Başlık */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 22, color: '#111827' }}>🚨 Hata, Usulsüzlük ve Yolsuzluk Bildirimleri</h1>
          <p style={{ margin: '4px 0 0', fontSize: 13, color: '#6b7280' }}>
            16. Standart • Kamu İç Kontrol Standartları Tebliği (26.12.2007)
          </p>
        </div>
        <button onClick={() => { setForm({ ...BOŞ }); setModal('yeni'); }} style={{
          background: '#dc2626', color: '#fff', border: 'none', borderRadius: 8,
          padding: '10px 20px', cursor: 'pointer', fontWeight: 600, fontSize: 14
        }}>+ Yeni Bildirim</button>
      </div>

      {/* Mevzuat Notu */}
      <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, padding: '12px 16px', marginBottom: 20 }}>
        <div style={{ fontSize: 13, color: '#991b1b', fontWeight: 600, marginBottom: 6 }}>⚖️ Yasal Yükümlülük — 16. Standart Genel Şartları:</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8, fontSize: 12, color: '#7f1d1d' }}>
          <div>📌 <strong>16.1</strong> Bildirim yöntemleri belirlenmeli ve duyurulmalıdır.</div>
          <div>📌 <strong>16.2</strong> Yöneticiler yeterli incelemeyi yapmalıdır.</div>
          <div>📌 <strong>16.3</strong> Bildiren personele haksız muamele yapılmamalıdır (ihbarcı koruması).</div>
        </div>
      </div>

      {/* KPI */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 12, marginBottom: 20 }}>
        {[
          { baslik: 'Toplam Bildirim', deger: bildirimler.length, ikon: '📋', bg: '#f3f4f6', renk: '#374151' },
          { baslik: 'Beklemede', deger: bekleyen, ikon: '⏳', bg: '#fef3c7', renk: '#92400e' },
          { baslik: 'İnceleniyor', deger: inceleniyor, ikon: '🔎', bg: '#dbeafe', renk: '#1e40af' },
          { baslik: 'Tamamlandı', deger: tamamlanan, ikon: '✅', bg: '#d1fae5', renk: '#065f46' },
        ].map(k => (
          <div key={k.baslik} style={{ background: k.bg, borderRadius: 10, padding: '16px 20px' }}>
            <div style={{ fontSize: 24, marginBottom: 4 }}>{k.ikon}</div>
            <div style={{ fontSize: 24, fontWeight: 800, color: k.renk }}>{k.deger}</div>
            <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>{k.baslik}</div>
          </div>
        ))}
      </div>

      {/* Filtreler */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 16, flexWrap: 'wrap' }}>
        <select value={filtreType} onChange={e => setFiltreType(e.target.value)}
          style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #d1d5db', fontSize: 13 }}>
          <option value="">Tüm Türler</option>
          {BILDIRIM_TURLERI.map(t => <option key={t.value} value={t.value}>{t.ikon} {t.label}</option>)}
        </select>
        <select value={filtreDurum} onChange={e => setFiltreDurum(e.target.value)}
          style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #d1d5db', fontSize: 13 }}>
          <option value="">Tüm Durumlar</option>
          {DURUMLAR.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
        </select>
      </div>

      {/* Tablo */}
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead style={{ background: '#f9fafb' }}>
            <tr>
              {['Bildirim No', 'Tür', 'Konu', 'Birim', 'Bildiren', 'Tarih', 'Durum', 'İşlem'].map(h => (
                <th key={h} style={{ padding: '10px 12px', textAlign: 'left', border: '1px solid #e5e7eb', color: '#374151', fontWeight: 600, whiteSpace: 'nowrap' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {bildirimler.length === 0 && (
              <tr><td colSpan={8} style={{ textAlign: 'center', padding: 40, color: '#9ca3af' }}>
                ✅ Henüz bildirim bulunmamaktadır.
              </td></tr>
            )}
            {bildirimler.map(b => {
              const tur = turBilgi(b.bildirim_turu);
              const dur = durumBilgi(b.durum);
              return (
                <tr key={b.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                  <td style={{ padding: '10px 12px', border: '1px solid #e5e7eb', fontFamily: 'monospace', color: '#374151', whiteSpace: 'nowrap' }}>{b.bildirim_no}</td>
                  <td style={{ padding: '10px 12px', border: '1px solid #e5e7eb', whiteSpace: 'nowrap' }}>
                    <span style={{ background: tur.bg, color: tur.renk, padding: '2px 8px', borderRadius: 12, fontSize: 12, fontWeight: 600 }}>
                      {tur.ikon} {tur.label}
                    </span>
                  </td>
                  <td style={{ padding: '10px 12px', border: '1px solid #e5e7eb', maxWidth: 250 }}>
                    <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: 600, color: '#111827' }}>{b.konu}</div>
                    {b.aciklama && <div style={{ fontSize: 11, color: '#6b7280', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{b.aciklama}</div>}
                  </td>
                  <td style={{ padding: '10px 12px', border: '1px solid #e5e7eb', color: '#6b7280' }}>{b.gerceklestigi_birim || '-'}</td>
                  <td style={{ padding: '10px 12px', border: '1px solid #e5e7eb', color: '#374151', fontSize: 12 }}>
                    {b.anonim_mi ? <span style={{ color: '#9ca3af', fontStyle: 'italic' }}>🔒 Anonim</span> : (b.bildiren_adi || '-')}
                  </td>
                  <td style={{ padding: '10px 12px', border: '1px solid #e5e7eb', color: '#6b7280', fontSize: 12, whiteSpace: 'nowrap' }}>
                    {b.olusturma_tarihi ? new Date(b.olusturma_tarihi).toLocaleDateString('tr-TR') : '-'}
                  </td>
                  <td style={{ padding: '10px 12px', border: '1px solid #e5e7eb' }}>
                    <span style={{ background: dur.bg, color: dur.text, padding: '2px 8px', borderRadius: 12, fontSize: 11, fontWeight: 600 }}>{dur.label}</span>
                  </td>
                  <td style={{ padding: '10px 12px', border: '1px solid #e5e7eb' }}>
                    <button onClick={() => { setSecili(b); setYeniDurum(b.durum); setIncelemeNotu(b.inceleme_notu || ''); setModal('detay'); }}
                      style={{ background: '#eff6ff', color: '#1d4ed8', border: 'none', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: 12 }}>
                      İncele
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Yeni Bildirim Modal */}
      {modal === 'yeni' && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: 640, maxHeight: '90vh', overflowY: 'auto', padding: 28 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
              <h2 style={{ margin: 0, fontSize: 18 }}>🚨 Yeni Bildirim</h2>
              <button onClick={() => setModal('')} style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#9ca3af' }}>×</button>
            </div>

            <div style={{ background: '#d1fae5', border: '1px solid #a7f3d0', borderRadius: 8, padding: '10px 14px', marginBottom: 16, fontSize: 12, color: '#065f46' }}>
              🔒 <strong>16.3. Şart Güvencesi:</strong> Bildirimde bulunan personele haksız ve ayırımcı muamele yapılmaz. Anonim bildirim seçeneğini kullanabilirsiniz.
            </div>

            <div style={{ display: 'grid', gap: 14 }}>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Bildirim Türü *</label>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 8 }}>
                  {BILDIRIM_TURLERI.map(t => (
                    <label key={t.value} style={{
                      display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4,
                      padding: '10px 6px', borderRadius: 8, cursor: 'pointer', textAlign: 'center',
                      border: `2px solid ${form.bildirim_turu === t.value ? t.renk : '#e5e7eb'}`,
                      background: form.bildirim_turu === t.value ? t.bg : '#fff'
                    }}>
                      <input type="radio" name="btur" value={t.value} checked={form.bildirim_turu === t.value}
                        onChange={() => setForm((f: any) => ({ ...f, bildirim_turu: t.value }))} style={{ display: 'none' }} />
                      <span style={{ fontSize: 20 }}>{t.ikon}</span>
                      <span style={{ fontSize: 11, fontWeight: 600, color: t.renk }}>{t.label}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Konu *</label>
                <input value={form.konu} onChange={e => setForm((f: any) => ({ ...f, konu: e.target.value }))}
                  placeholder="Bildirimin konusu..." style={girisS()} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Açıklama *</label>
                <textarea value={form.aciklama} onChange={e => setForm((f: any) => ({ ...f, aciklama: e.target.value }))}
                  rows={4} placeholder="Olayın ayrıntılı açıklaması, ne zaman ve nasıl gerçekleştiği..."
                  style={{ ...girisS(), resize: 'vertical' }} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Gerçekleştiği Birim</label>
                <input value={form.gerceklestigi_birim} onChange={e => setForm((f: any) => ({ ...f, gerceklestigi_birim: e.target.value }))}
                  placeholder="İşletme veya birim adı" style={girisS()} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Tahmini Etki</label>
                <textarea value={form.tahmini_etki} onChange={e => setForm((f: any) => ({ ...f, tahmini_etki: e.target.value }))}
                  rows={2} placeholder="Olayın tahmini mali veya kurumsal etkisi..."
                  style={{ ...girisS(), resize: 'vertical' }} />
              </div>

              {/* Anonim Seçeneği */}
              <div style={{ background: '#f9fafb', borderRadius: 8, padding: 14 }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', marginBottom: form.anonim_mi ? 0 : 10 }}>
                  <input type="checkbox" checked={form.anonim_mi} onChange={e => setForm((f: any) => ({ ...f, anonim_mi: e.target.checked }))}
                    style={{ width: 18, height: 18, accentColor: '#1d4ed8' }} />
                  <span style={{ fontSize: 14, fontWeight: 600, color: '#374151' }}>🔒 Anonim Bildirim</span>
                </label>
                {!form.anonim_mi && (
                  <div style={{ marginTop: 10 }}>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Ad Soyad</label>
                    <input value={form.bildiren_adi} onChange={e => setForm((f: any) => ({ ...f, bildiren_adi: e.target.value }))}
                      placeholder="Bildirimi yapan kişinin adı" style={girisS()} />
                  </div>
                )}
              </div>
            </div>

            <div style={{ display: 'flex', gap: 12, marginTop: 20, justifyContent: 'flex-end' }}>
              <button onClick={() => setModal('')} style={{ padding: '10px 20px', borderRadius: 8, border: '1px solid #d1d5db', background: '#fff', cursor: 'pointer', fontSize: 14 }}>İptal</button>
              <button onClick={kaydet} disabled={kaydediliyor || !form.konu || !form.aciklama} style={{
                padding: '10px 24px', borderRadius: 8, border: 'none', fontSize: 14, fontWeight: 600, cursor: 'pointer',
                background: (!form.konu || !form.aciklama) ? '#9ca3af' : '#dc2626', color: '#fff'
              }}>{kaydediliyor ? 'Gönderiliyor...' : 'Bildirimi Gönder'}</button>
            </div>
          </div>
        </div>
      )}

      {/* Detay / İnceleme Modal */}
      {modal === 'detay' && secili && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: 640, maxHeight: '90vh', overflowY: 'auto', padding: 28 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
              <h2 style={{ margin: 0, fontSize: 18 }}>🔎 Bildirim İncele — {secili.bildirim_no}</h2>
              <button onClick={() => setModal('')} style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#9ca3af' }}>×</button>
            </div>

            {/* Bildirim Detayları */}
            <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8, padding: 16, marginBottom: 20 }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, fontSize: 13 }}>
                <Satir baslik="Bildirim No" deger={secili.bildirim_no} />
                <Satir baslik="Tür" deger={`${turBilgi(secili.bildirim_turu).ikon} ${turBilgi(secili.bildirim_turu).label}`} />
                <Satir baslik="Birim" deger={secili.gerceklestigi_birim || '-'} />
                <Satir baslik="Bildiren" deger={secili.anonim_mi ? '🔒 Anonim' : (secili.bildiren_adi || '-')} />
                <Satir baslik="Tarih" deger={secili.olusturma_tarihi ? new Date(secili.olusturma_tarihi).toLocaleDateString('tr-TR') : '-'} />
                <Satir baslik="Mevcut Durum" deger={durumBilgi(secili.durum).label} />
              </div>
              <div style={{ marginTop: 12 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Konu</div>
                <div style={{ fontSize: 13, color: '#111827', fontWeight: 600 }}>{secili.konu}</div>
              </div>
              <div style={{ marginTop: 10 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Açıklama</div>
                <div style={{ fontSize: 13, color: '#374151', lineHeight: 1.6 }}>{secili.aciklama}</div>
              </div>
              {secili.tahmini_etki && (
                <div style={{ marginTop: 10 }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Tahmini Etki</div>
                  <div style={{ fontSize: 13, color: '#374151' }}>{secili.tahmini_etki}</div>
                </div>
              )}
            </div>

            {/* İnceleme Bölümü */}
            <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 8, padding: 16 }}>
              <h3 style={{ margin: '0 0 12px', fontSize: 14, color: '#1e40af' }}>📝 İnceleme Sonucu (16.2. Şart)</h3>
              <div style={{ marginBottom: 12 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Durum Güncelle</label>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 8 }}>
                  {DURUMLAR.map(d => (
                    <label key={d.value} style={{
                      display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px',
                      borderRadius: 8, cursor: 'pointer', border: `2px solid ${yeniDurum === d.value ? '#3b82f6' : '#e5e7eb'}`,
                      background: yeniDurum === d.value ? '#eff6ff' : '#fff'
                    }}>
                      <input type="radio" name="yDurum" value={d.value} checked={yeniDurum === d.value}
                        onChange={() => setYeniDurum(d.value)} style={{ accentColor: '#3b82f6' }} />
                      <span style={{ background: d.bg, color: d.text, padding: '1px 8px', borderRadius: 10, fontSize: 12, fontWeight: 600 }}>{d.label}</span>
                    </label>
                  ))}
                </div>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>İnceleme Notu</label>
                <textarea value={incelemeNotu} onChange={e => setIncelemeNotu(e.target.value)}
                  rows={3} placeholder="İnceleme sonucu, yapılan işlemler ve alınan kararlar..."
                  style={{ width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13, resize: 'vertical', boxSizing: 'border-box' }} />
              </div>
            </div>

            <div style={{ display: 'flex', gap: 12, marginTop: 20, justifyContent: 'flex-end' }}>
              <button onClick={() => setModal('')} style={{ padding: '10px 20px', borderRadius: 8, border: '1px solid #d1d5db', background: '#fff', cursor: 'pointer', fontSize: 14 }}>Kapat</button>
              <button onClick={durumGuncelle} disabled={kaydediliyor} style={{
                padding: '10px 24px', borderRadius: 8, border: 'none', fontSize: 14, fontWeight: 600, cursor: 'pointer',
                background: '#1d4ed8', color: '#fff'
              }}>{kaydediliyor ? 'Kaydediliyor...' : 'Güncelle'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function Satir({ baslik, deger }: { baslik: string; deger: string }) {
  return (
    <div>
      <div style={{ fontSize: 11, color: '#9ca3af', marginBottom: 2 }}>{baslik}</div>
      <div style={{ fontSize: 13, color: '#111827', fontWeight: 500 }}>{deger}</div>
    </div>
  );
}

function girisS(): React.CSSProperties {
  return { width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13, outline: 'none', boxSizing: 'border-box' };
}
